import { render, staticRenderFns } from "./businessRegister.vue?vue&type=template&id=bb831d54&scoped=true&"
import script from "./businessRegister.vue?vue&type=script&lang=js&"
export * from "./businessRegister.vue?vue&type=script&lang=js&"
import style0 from "./businessRegister.vue?vue&type=style&index=0&id=bb831d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb831d54",
  null
  
)

export default component.exports